import type { ReactNode } from 'react';
import { useState } from 'react';
import { Header } from './Header';
import { Lightbox } from './Lightbox';
import type { LightboxCaption, LightboxImageSize } from './Lightbox';

interface ProposalImage {
  id: number;
  src: string;
  alt: string;
  title: string;
  author: string;
  href?: string;
  cropClassName?: string;
  imageClassName?: string;
  mobileVisible?: boolean;
}

const photographImages: ProposalImage[] = [
  {
    id: 50800494,
    src: 'https://images.are.na/eyJidWNrZXQiOiJhcmVuYV9pbWFnZXMiLCJrZXkiOiI1MDgwMDQ5NC9vcmlnaW5hbF8wZmZjYjE3ODBjMDI1YzExNzkzNzA0ZGRkNzgwNmMyMC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyMDAsImhlaWdodCI6MTIwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfSwid2VicCI6eyJxdWFsaXR5Ijo3NX0sImpwZWciOnsicXVhbGl0eSI6NzV9LCJyb3RhdGUiOm51bGx9fQ==?bc=0',
    alt: 'Children playing on front lawn',
    title: 'Children playing on front lawn',
    author: 'Leonard Nadel',
    href: 'https://tessa2.lapl.org/digital/collection/photos/id/1166/rec/2',
    mobileVisible: true,
  },
  {
    id: 50800496,
    src: 'https://images.are.na/eyJidWNrZXQiOiJhcmVuYV9pbWFnZXMiLCJrZXkiOiI1MDgwMDQ5Ni9vcmlnaW5hbF9mYjQzMWNkZmEwNjJhM2E5NDc3M2VmOTAwMGI3MjRjYi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyMDAsImhlaWdodCI6MTIwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfSwid2VicCI6eyJxdWFsaXR5Ijo3NX0sImpwZWciOnsicXVhbGl0eSI6NzV9LCJyb3RhdGUiOm51bGx9fQ==?bc=0',
    alt: 'Residents maintaining yards at housing project',
    title: 'Residents maintaining yards at housing project',
    author: 'Leonard Nadel',
    href: 'https://tessa2.lapl.org/digital/collection/photos/id/1165/rec/1',
  },
  {
    id: 50800500,
    src: 'https://images.are.na/eyJidWNrZXQiOiJhcmVuYV9pbWFnZXMiLCJrZXkiOiI1MDgwMDUwMC9vcmlnaW5hbF83YjZmN2EyMzFhZDllY2IzYTRhYTYyOGJhOTc1NTdjMC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyMDAsImhlaWdodCI6MTIwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfSwid2VicCI6eyJxdWFsaXR5Ijo3NX0sImpwZWciOnsicXVhbGl0eSI6NzV9LCJyb3RhdGUiOm51bGx9fQ==?bc=0',
    alt: 'Project Garden of the Month contest winner',
    title: 'Project’s "Garden of the Month" contest winner',
    author: 'Leonard Nadel',
    href: 'https://tessa2.lapl.org/digital/collection/photos/id/1167/rec/3',
  },
];

const paintingImages: ProposalImage[] = [
  {
    id: 50799976,
    src: 'https://images.are.na/eyJidWNrZXQiOiJhcmVuYV9pbWFnZXMiLCJrZXkiOiI1MDc5OTk3Ni9vcmlnaW5hbF9mODEyMzI0ZDVjOGM4MTZjMmY3YjdlMTRmMjJkZWFkMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyMDAsImhlaWdodCI6MTIwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfSwid2VicCI6eyJxdWFsaXR5Ijo3NX0sImpwZWciOnsicXVhbGl0eSI6NzV9LCJyb3RhdGUiOm51bGx9fQ==?bc=0',
    alt: 'Noah Davis: Pueblo Del Rio: Prelude, 2014',
    title: 'Pueblo Del Rio: Prelude',
    author: 'Noah Davis',
    href: 'https://www.davidzwirner.com/artworks/noah-davis-pueblo-del-rio-prelude-dv30s',
    cropClassName: 'relative aspect-[3/2] overflow-hidden',
    imageClassName:
      'absolute max-w-none w-[121%] -translate-x-[8.5%] -translate-y-[13%]',
  },
  {
    id: 50799987,
    src: 'https://images.are.na/eyJidWNrZXQiOiJhcmVuYV9pbWFnZXMiLCJrZXkiOiI1MDc5OTk4Ny9vcmlnaW5hbF84ZDg0YTM1NmViODU2ODRkN2E5ZWI2YmYwZWNhZjg3ZS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyMDAsImhlaWdodCI6MTIwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfSwid2VicCI6eyJxdWFsaXR5Ijo3NX0sImpwZWciOnsicXVhbGl0eSI6NzV9LCJyb3RhdGUiOm51bGx9fQ==?bc=0',
    alt: 'Pueblo Del Rio: Vernon by Noah Davis',
    title: 'Pueblo Del Rio: Vernon',
    author: 'Noah Davis',
    href: 'https://www.whitecube.com/artworks/noah-davis-pueblo-del-rio-vernon-70448',
    mobileVisible: true,
    cropClassName: 'relative aspect-[1.1/1] overflow-hidden',
    imageClassName:
      'absolute max-w-none w-[144%] -translate-x-[15%] -translate-y-[7.5%]',
  },
  {
    id: 50799996,
    src: 'https://images.are.na/eyJidWNrZXQiOiJhcmVuYV9pbWFnZXMiLCJrZXkiOiI1MDc5OTk5Ni9vcmlnaW5hbF82OTAyNTI5ODY4YjBiODI5MTMxMjllMDMwZjQ1YTg1MS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjEyMDAsImhlaWdodCI6MTIwMCwiZml0IjoiaW5zaWRlIiwid2l0aG91dEVubGFyZ2VtZW50Ijp0cnVlfSwid2VicCI6eyJxdWFsaXR5Ijo3NX0sImpwZWciOnsicXVhbGl0eSI6NzV9LCJyb3RhdGUiOm51bGx9fQ==?bc=0',
    alt: 'Noah Davis Pueblo Del Rio Arabesque reference',
    title: 'Pueblo Del Rio: Arabesque',
    author: 'Noah Davis',
    href: 'http://www.papillionart.com/photo-gallery/noah-davis-garden-city/19678606',
  },
];

const vanDykeImages: ProposalImage[] = [
  {
    id: 1,
    src: 'https://assets.salieflewis.com/slide_one.png',
    alt: 'Van Dyke print: Untitled (Milk Crate)',
    title: 'Van Dyke: Untitled (Milk Crate)',
    author: 'Salief Lewis',
    mobileVisible: true,
  },
  {
    id: 2,
    src: 'https://assets.salieflewis.com/slide_two.png',
    alt: 'Van Dyke print: Dancing Feet',
    title: 'Van Dyke: Dancing Feet',
    author: 'Salief Lewis',
  },
  {
    id: 3,
    src: 'https://assets.salieflewis.com/slide_three.png',
    alt: 'Van Dyke print: Untitled (Painted Plank)',
    title: 'Van Dyke: Untitled (Painted Plank)',
    author: 'Salief Lewis',
  },
];

const vanDykeLightboxImages = vanDykeImages.map((image) => image.src);

const vanDykeLightboxCaptions: LightboxCaption[] = [
  {
    title: 'Untitled (Milk Crate)',
    year: '2026',
  },
  {
    title: 'Dancing Feet',
    year: '2026',
  },
  {
    title: 'Untitled (Painted Plank)',
    year: '2026',
  },
];

const vanDykeImageSizes: LightboxImageSize[] = [
  {
    width: 1080,
    height: 1350,
  },
  {
    width: 1080,
    height: 1350,
  },
  {
    width: 1080,
    height: 1350,
  },
];

const briefParagraphs = [
  "Using Nadel's photographs as a point of departure, I would spend time at Pueblo Del Rio developing relationships with residents and learning more about the community's cultural history, memory, and present-day life. I am interested in how Nadel's compositions, subjects, and attention to everyday experience might inform a contemporary photographic response.",
  "The project would result in a series of photographs and archival Van Dyke Brown prints incorporating community spaces, objects, and portraits of residents. The prints' historical appearance and tactile materiality would acknowledge the period in which Nadel was working while also connecting the project to the physical and painterly qualities of the late Noah Davis's work related to Pueblo Del Rio.",
  "Through the library's collections, services, and support, this project would explore how photographs help construct and complicate the histories of place, community, and belonging. The library would serve not only as a source of historical material, but also as a creative resource where archival research, public memory, and contemporary artistic practice can meet. By returning the project to the library through an exhibition, presentation, or public program, I hope to highlight the library's role as a creative incubator and as a space where communities can encounter, preserve, and reimagine their own histories.",
];

const nadelArchiveUrl =
  'https://tessa2.lapl.org/digital/collection/photos/search/searchterm/nadel%2C%20leonard./field/creato/mode/exact/conn/and';
const puebloDelRioUrl = 'https://en.wikipedia.org/wiki/Pueblo_Del_Rio';

export function LaplCreatorsInResidence() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const handleVanDykeImageClick = (index: number) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const handleCloseLightbox = () => {
    setLightboxOpen(false);
    setCurrentImageIndex(0);
  };

  return (
    <>
      <div className="min-h-dvh bg-white text-black">
        <Header
          title={
            <>
              <span className="font-light opacity-50">Proposal</span>
              {' / '}
              LAPL Creators in Residence
            </>
          }
        />
        <main className="mx-auto flex w-full max-w-[1440px] flex-col gap-12 px-4 pb-24 pt-8 md:gap-16 md:px-8 md:pt-14">
          <ProposalText>
            A new body of photographic work inspired by the Los Angeles Public
            Library's archive of photojournalist{' '}
            <a
              href={nadelArchiveUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-1 decoration-black underline-offset-4 transition-opacity duration-200 ease-in-out hover:opacity-70"
            >
              Leonard Nadel
            </a>
            , particularly his documentation of public housing and the{' '}
            <a
              href={puebloDelRioUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-1 decoration-black underline-offset-4 transition-opacity duration-200 ease-in-out hover:opacity-70"
            >
              Pueblo Del Rio
            </a>{' '}
            community. Built in 1941 by architects including Richard Neutra and
            Paul R. Williams, Pueblo Del Rio represents both an ambitious
            experiment in public housing and the complicated legacy of modernist
            planning during the Jim Crow era.
          </ProposalText>

          <ImageRow
            images={photographImages}
            className="w-[58vw] max-w-[260px] md:w-full md:max-w-[300px]"
            eagerFirst
          />

          <ProposalText>{briefParagraphs[0]}</ProposalText>

          <ImageRow
            images={paintingImages}
            className="w-[66vw] max-w-[320px] md:w-full md:max-w-[340px]"
          />

          <ProposalText>{briefParagraphs[1]}</ProposalText>

          <ImageRow
            images={vanDykeImages}
            className="w-[58vw] max-w-[260px] md:w-full md:max-w-[300px]"
            onImageClick={handleVanDykeImageClick}
          />

          <ProposalText>{briefParagraphs[2]}</ProposalText>
        </main>
      </div>

      {lightboxOpen && (
        <Lightbox
          images={vanDykeLightboxImages}
          caption={vanDykeLightboxCaptions[0]}
          captions={vanDykeLightboxCaptions}
          imageSizes={vanDykeImageSizes}
          currentIndex={currentImageIndex}
          onClose={handleCloseLightbox}
          onNavigate={setCurrentImageIndex}
        />
      )}
    </>
  );
}

function ProposalText({ children }: { children: ReactNode }) {
  return (
    <section className="mx-auto max-w-[780px] text-center text-base font-light leading-relaxed md:text-xl">
      <p>{children}</p>
    </section>
  );
}

function ImageRow({
  images,
  className,
  eagerFirst = false,
  showAllOnMobile = false,
  onImageClick,
}: {
  images: ProposalImage[];
  className: string;
  eagerFirst?: boolean;
  showAllOnMobile?: boolean;
  onImageClick?: (index: number) => void;
}) {
  return (
    <section
      className="grid grid-cols-1 items-center justify-items-center gap-8 md:grid-cols-3 md:gap-10"
      aria-label="Reference images"
    >
      {images.map((image, index) => (
        <ProposalFigure
          key={image.id}
          image={image}
          loading={eagerFirst && index === 0 ? 'eager' : 'lazy'}
          fetchPriority={eagerFirst && index === 0 ? 'high' : 'auto'}
          onClick={onImageClick ? () => onImageClick(index) : undefined}
          className={`${className} ${
            showAllOnMobile || image.mobileVisible ? '' : 'hidden md:flex'
          }`}
        />
      ))}
    </section>
  );
}

function ProposalFigure({
  image,
  loading,
  fetchPriority,
  onClick,
  className,
}: {
  image: ProposalImage;
  loading: 'eager' | 'lazy';
  fetchPriority: 'high' | 'auto';
  onClick?: () => void;
  className: string;
}) {
  const renderedImage = (
    <div className={image.cropClassName}>
      <img
        src={image.src}
        alt={image.alt}
        width={1200}
        height={1200}
        loading={loading}
        decoding="async"
        fetchPriority={fetchPriority}
        className={image.imageClassName ?? 'h-auto w-full object-contain'}
      />
    </div>
  );

  return (
    <figure
      className={`flex origin-center flex-col gap-1.5 transition-transform duration-500 ease-out md:hover:scale-[1.02] ${className}`}
    >
      {image.href ? (
        <a href={image.href} target="_blank" rel="noopener noreferrer">
          {renderedImage}
        </a>
      ) : onClick ? (
        <button
          type="button"
          className="border-0 bg-transparent p-0 text-left"
          onClick={onClick}
        >
          {renderedImage}
        </button>
      ) : (
        renderedImage
      )}
      <figcaption className="text-xs font-light leading-relaxed text-black md:text-sm">
        <span className="block">{image.author}</span>
        <span className="block italic">{image.title}</span>
      </figcaption>
    </figure>
  );
}
